/**
 * FoundingSeatsCounter — live "only X/50 Founding seats left" widget.
 * Self-fetches the public pricing config; safe to drop on any public page.
 */
import React, { useState, useEffect } from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const FoundingSeatsCounter = ({ compact = false }) => {
  const { language } = useLanguage();
  const t = (hi, en) => (language === 'hi' ? hi : en);
  const [stats, setStats] = useState(null);

  useEffect(() => {
    let cancelled = false;
    fetch(`${API_URL}/api/config/pricing`)
      .then((r) => r.json())
      .then((d) => { if (!cancelled && d?.founding_schools_stats) setStats(d.founding_schools_stats); })
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);

  if (!stats) return null;
  const { remaining, total_slots, percent_filled, is_open } = stats;

  // Founding Offer hidden — platform is 100% FREE. Render nothing.
  if (!is_open) return null;

  return (
    <div className="rounded-xl bg-gradient-to-r from-amber-50 to-orange-50 border border-orange-200 px-4 py-3" data-testid="founding-seats-counter">
      <div className="flex items-baseline justify-between gap-2">
        <span className="text-xs font-bold text-orange-700 uppercase tracking-wide">
          🔥 {t('Founding Offer', 'Founding Offer')}
        </span>
        <span className="text-sm font-extrabold text-slate-900">
          {t('सिर्फ', 'Only')} <span data-testid="founding-counter-remaining">{remaining}</span>
          <span className="text-slate-400 font-bold">/{total_slots}</span> {t('seats बचे', 'seats left')}
        </span>
      </div>
      {!compact && (
        <div className="mt-2 h-2 w-full rounded-full bg-orange-100 overflow-hidden">
          <div
            className="h-full rounded-full bg-gradient-to-r from-orange-500 to-red-500 transition-all duration-500"
            style={{ width: `${Math.max(4, percent_filled)}%` }}
          />
        </div>
      )}
    </div>
  );
};

export default FoundingSeatsCounter;
